import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import appConfig from '@/config';
import commonTheme from '@/Theme';

class ErrorApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('Error boundary', error);
    this.setState({hasError: true});
  }

  backLogin = () => {
    this.setState({hasError: false});
    location.href = appConfig.BACK_TO_LOGIN;
  };

  render() {
    if (this.state.hasError) {
      return (
        <ThemeProvider theme={commonTheme}>
          <Stack
            spacing={1}
            sx={{
              my: 2,
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Typography variant="h5">
              予期せぬエラーが発生しました。
            </Typography>

            <Typography variant="h5">
              ログイン画面から再度やり直してください。
            </Typography>

            <Button
              variant="contained"
              sx={{ px: 5, py: 1 }}
              onClick={this.backLogin}
            >
              OK
            </Button>
          </Stack>
        </ThemeProvider>
      );
    }
    return this.props.children;
  }
}

ErrorApp.propTypes ={
  children: PropTypes.object,
};
export default ErrorApp;
